import React from "react";
import styles from "./css/ProjectCard.module.css";
import { Project } from "@/types";
import { RootState } from "@/store/store";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { formatDateWithTime } from "@/utils/date";
import TruncateText from "../addons/TruncatedText";
import ProjectImageNotFound from "@/assets/projectImageNotExists.png";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCurrentProject } from "@/store/projectsSlice";
import { PencilWriting } from "@/icons/PencilWriting";


interface ProjectCardProps {
    project: Project;
}

export const ProjectCard: React.FC<ProjectCardProps> = ({ project }) => {
    const {cityId} = useParams();
    const city = useSelector((state: RootState) => state.entity.userCity) || useSelector((state: RootState) => state.entity.cities.find(city => city.id === cityId)) || null;
    const {t}= useTranslation('ProjectsPage');
    const navigate = useNavigate();
    const {entityName} = useParams<{entityName: string}>();
    const dispatch = useDispatch();

    const handleClick = () => {
        if (project) {
            dispatch(setCurrentProject(project));
            navigate(`/${entityName}/project/${city?.id}/${project.id}`);
        }
    }

    const handleEditProject = () => {
        navigate(`/${entityName}/project/${city?.id}/${project.id}/update`);
    }

    return (
        <a 
            onClick={(e) => {
                e.preventDefault();
                handleClick();
            }}
            className={styles.container}
        >
            <div className={styles.img}>
                {project?.image ? (
                    <img 
                        src={project.image} 
                        alt="Project" 
                        className={styles.projectImage}
                    />
                ) : (
                    <div className={styles.noImage}>
                        <img src={ProjectImageNotFound} alt="Project" />
                    </div>
                )}
            </div>
            <div className={styles.info}>
                <div className={styles.projectName}>
                    {TruncateText({text: project.name, maxLength: 18})}
                </div>
                <div className={styles.projectLastUpdated}>
                    <div className={styles.projectLastUpdatedDate}>
                        {formatDateWithTime(project.last_updated)}
                    </div>
                    {t('lastUpdateTile')}
                </div>
                <div className={styles.createdBy}>
                    {project.created_by}
                </div>
            </div>
            <div className={styles.actions}>
                <button className={styles.editButton} onClick={(e) => {e.stopPropagation(); handleEditProject()} }>
                    <PencilWriting className={styles.editIcon} />
                </button>
            </div>
        </a>
    );
}